import React, { Component } from 'react';

import { withRouteOptions } from 'components/hocs/withRouteOptions';
import FileLibraryTable from './FileLibraryTable';

@withRouteOptions
export default class FileLibrary extends Component {
    static routeOptions = {
        title: 'menu.fileLibrary'
    }

    render() {
        return (
            <FileLibraryTable {...this.props} />
        )
    }
}
